module.exports = __webpack_public_path__ + "static/media/inspector-icon-active.2a55d39b.svg";